import React from "react";
import Icon from "../icon/Icon";

const LoadingIndicator: React.FC = (): React.ReactElement => {
  return <Icon className="flex animate-spin justify-center" name="loading" />;
};

export default LoadingIndicator;
